<template>
    <div>
        <dl class="description-list-wrapper">
            <DescriptionItem :label="$t('캠페인 규칙셋명')">
                {{ detailData.name || '-' }}
            </DescriptionItem>

            <DescriptionItem :label="$t('연결 프로젝트')">
                {{ getTargetProjectText || '-' }}
            </DescriptionItem>
            <DescriptionItem :label="$t('연결 캠페인')">
                {{ getTargetCampaignText || '-' }}
            </DescriptionItem>

            <DescriptionItem :label="$t('연결 규칙 그룹')">
                <b-button variant="link" style="padding: 0"
                          @click="openRuleGroupDetail"
                >
                    {{ detailData.root_rule_group?.name || '-' }}
                </b-button>
            </DescriptionItem>

            <DescriptionItem :label="$t('활성여부')">
                <b-badge :variant="getIsActiveData.variant" class="f-90">
                         {{ getIsActiveData.text }}
                </b-badge>
            </DescriptionItem>

            <DescriptionItem :label="$t('설명')">
                {{ detailData.description || '-' }}
            </DescriptionItem>

            <div class="row-wrapper">
                <DescriptionItem :label="$t('등록일시')">
                    {{ get_date(detailData.created_at) || '-' }}
                </DescriptionItem>

                <DescriptionItem :label="$t('수정일시')">
                    {{ get_date(detailData.updated_at) || '-' }}
                </DescriptionItem>
            </div>
        </dl>
        <RuleGroupModal ref="ruleGroupModal"
                        :detail-id="ruleGroupDetailId"
        />
    </div>
   
</template>

<script>
import DescriptionItem from '@shared/components/common/DescriptionItem.vue';
import {
    getDate,
    getTargetCampaignText,
    getTargetProjectText
} from '@shared/components/admin/pages/Management/common-data';
import RuleGroupModal from '@shared/components/admin/pages/Management/CampaignConnectRule/RuleGroup/RuleGroupModal.vue';

export default {
    name: 'CampaignRuleSetDetail',
    components: {
        RuleGroupModal,
        DescriptionItem
    },
    props: {
        detailData: {
            type: Object,
            required: true,
            default: () => ({id: null}),
        },
        campaigns: {
            type: [Array, null],
            default: null,
        },
        projects: {
            type: [Array, null],
            default: null,
        }
    },
    data() {
        return {
            ruleGroupDetailId: null
        };
    },
    computed: {
        getTargetProjectText(){
            return getTargetProjectText(this.detailData.project_id, this.projects);
        },
        getTargetCampaignText(){
            return getTargetCampaignText(this.detailData.campaign_id, this.campaigns);
        },
        getIsActiveData(){
            return {
                variant: this.detailData.is_active ? 'success' : 'secondary',
                text: this.detailData.is_active ? this.$t('활성') : this.$t('비활성'),
            };
        },
        get_date() {
            return (date) => {
                return getDate(date);
            };
        },
    },
    methods: {
        openRuleGroupDetail(){
            this.ruleGroupDetailId = this.detailData?.root_rule_group.id;
            this.$refs.ruleGroupModal.changeMode('readOnly');
            this.$bvModal.show('rule-group-detail-modal');
        },

    },
};
</script>
<style lang="scss" scoped>

</style>
